module.exports = __webpack_public_path__ + "static/img/pet-friendly-white.9dad4c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pet-friendly-white.png
// module id = 298s
// module chunks = 1